import React from 'react';
import { FaPlay } from 'react-icons/fa6';
import './PauseOverlay.scss';

// 一時停止中に画面全体を覆う。中央の再生ボタンで再開する。
// 広告をクリックして別タブへ移ったときも、戻ってきたらこの状態で待っている。
const PauseOverlay = ({ onResume }) => (
  <div className="pause-overlay" onClick={onResume} role="presentation">
    <button
      type="button"
      className="pause-resume"
      onClick={(e) => {
        e.stopPropagation();
        onResume();
      }}
      aria-label="再生する"
    >
      <FaPlay aria-hidden="true" />
    </button>
    <p className="pause-note">一時停止中</p>
  </div>
);

export default PauseOverlay;
